import { memo } from 'react';
import { CartContainer } from '@aimsos/ui';

/**
 * A one-line notice above the Insights grid (CT-5716): "Not enough of a pattern
 * yet · N interactions so far" or "Insights are paused · Gmail data missing
 * since …". The grid still renders below it.
 */
const InsightsNotice = memo(function InsightsNotice({ icon: Icon, children, testId }) {
  return (
    <div data-testid={testId}>
      <CartContainer size="S" variant="neutral">
        <p className="flex items-center gap-2 text-sm text-content-secondary">
          {Icon ? <Icon size={16} aria-hidden className="shrink-0" /> : null}
          {children}
        </p>
      </CartContainer>
    </div>
  );
});

export default InsightsNotice;
